import { useIntl } from 'react-intl';

import { Button } from './Button';

export interface BannerSubscriptionProps {
  title: string;
  description: string;
  buttonLabel: string;
  link: string;
}

export const BannerSubscription = ({
  title,
  description,
  buttonLabel,
  link,
}: BannerSubscriptionProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="relative p-1 rounded-2xl bg-majelan m-6">
      <div className="bg-brand-neutral-700 rounded-xl p-10">
        <div className="flex relative flex-col content-center items-center w-full h-full z-[1]">
          <h1 className="font-bold leading-normal tracking-[0.4px] text-center mb-2.5 text-[24px] lg:text-[40px]">
            {formatMessage({ id: title })}
          </h1>
          <span className="w-full text-center mb-[40px] text-[17px] lg:leading-[1.26px] text-brand-neutral-300 lg:text-[18px] px-12 drop-shadow sm:drop-shadow-0">
            {formatMessage({ id: description })}
          </span>
          <Button style="primary" link={link} className="h-10">
            <span className="font-medium text-center text-[14px] before:m-[1px] p-10">
              {formatMessage({ id: buttonLabel })}
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};
